import { useNavigate } from 'react-router-dom';
import ManorShell from './ManorShell';

// Title screen (home.php) — Begin starts stage 1.
export default function ManorHome() {
  const navigate = useNavigate();
  return (
    <ManorShell bg="home1/bg.png" bgMob="img/home1/bg_mob.jpg" bgSize="cover">
      <img className="manor-drop manor-title" style={{ top: 0 }} src="/manor/img/home1/title.png" alt="The Haunting of Hollow Manor" />
      <button type="button" className="manor-img-btn manor-home-begin" onClick={() => navigate('/manor/stage1')}>
        <img src="/manor/img/home1/Begin.png" alt="Begin" />
      </button>
    </ManorShell>
  );
}
